import { useEffect, useState } from "react";
import { safeGetItem, safeSetItem } from "@/lib/safeStorage";

const STORAGE_KEY = "ns_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!safeGetItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    safeSetItem(STORAGE_KEY, "1");
    setFading(true);
    setTimeout(() => setVisible(false), 500);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        opacity: fading ? 0 : 1,
        transition: "opacity 0.5s ease",
        background: "rgba(10, 10, 10, 0.96)",
        backdropFilter: "blur(12px)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        padding: "16px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "24px",
        flexWrap: "wrap",
      }}
    >
      <p style={{
        margin: 0,
        color: "rgba(255,255,255,0.65)",
        fontSize: "13px",
        fontWeight: 300,
        letterSpacing: "0.02em",
        maxWidth: "640px",
      }}>
        We use cookies to improve your experience and analyze site traffic.
        By continuing, you consent to our use of cookies.{" "}
        <a
          href="#"
          style={{ color: "#A8B5A2", textDecoration: "none", borderBottom: "1px solid rgba(168,181,162,0.4)" }}
          onClick={(e) => e.preventDefault()}
        >
          Learn more
        </a>
      </p>
      <button
        onClick={handleAccept}
        aria-label="Accept cookies and close this banner"
        style={{
          background: "transparent",
          border: "1px solid rgba(168,181,162,0.5)",
          borderRadius: "50px",
          color: "#A8B5A2",
          fontSize: "12px",
          fontWeight: 400,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          padding: "8px 24px",
          cursor: "pointer",
          transition: "all 0.3s ease",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "rgba(168,181,162,0.12)";
          (e.currentTarget as HTMLButtonElement).style.boxShadow = "0 0 0 3px rgba(168,181,162,0.2)";
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "transparent";
          (e.currentTarget as HTMLButtonElement).style.boxShadow = "none";
        }}
      >
        Accept
      </button>
    </div>
  );
}
